import { StringEncoder } from "./controls";
import { TryParseInt, IsError, TryParseFloat } from "./functional";

export const StrEncoder: StringEncoder<string> = {
	FromString(v) {
		return v;
	},

	ToString(v) {
		return v;
	},
};

export function NewIntEncoder(defaultValue: number): StringEncoder<number> {
	return {
		ToString(v) {
			return v.toString();
		},
		FromString(v) {
			const maybeInt = TryParseInt(v);
			if (IsError(maybeInt)) {
				return defaultValue;
			}
			return maybeInt;
		},
	};
}

export function NewFloatEncoder(defaultValue: number): StringEncoder<number> {
	return {
		ToString(v) {
			return v.toString();
		},
		FromString(v) {
			const maybeInt = TryParseFloat(v);
			if (IsError(maybeInt)) {
				return defaultValue;
			}
			return maybeInt;
		},
	};
}